
import { Component, Vue, Prop } from "vue-property-decorator";
import PersonIcon from "@/modules/Compliance/Widgets/assets/icons/person.svg";
import StartIcon from "@/modules/Compliance/Widgets/assets/icons/star.svg";
import VisaIcon from "@/modules/Compliance/Widgets/assets/icons/visa.svg";
import VisaIconDisabled from "@/modules/Compliance/Widgets/assets/icons/visa-disabled.svg";

const CLASS = "block";

const TYPE_DEFAULT = "purple";
const TYPE_WHITE = "white";
const TYPE_BLUE = "blue";
const TYPE_PURPLE = "purple";
const TYPES = [TYPE_DEFAULT, TYPE_BLUE, TYPE_PURPLE];

const ICON_DEFAULT = "";
const ICON_VISA = "visa";
const ICON_STAR = "star";
const ICONS = [ICON_DEFAULT, ICON_VISA, ICON_STAR];

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
  },
})
export default class IconButtonBlock extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly label!: string;
  @Prop({ type: String, default: "" }) readonly hint!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly short!: boolean;
  @Prop({ type: String, default: PersonIcon }) readonly image!: string;
  @Prop({ type: String, default: "" }) readonly imageDisabled!: string;
  @Prop({
    type: String,
    validator: (value: string) => TYPES.includes(value),
    default: TYPE_DEFAULT,
  })
  readonly type?: string;
  @Prop({
    type: String,
    validator: (value: string) => ICONS.includes(value),
    default: ICON_DEFAULT,
  })
  readonly icon?: string;

  personIcon = PersonIcon;
  starIcon = StartIcon;
  visaIcon = VisaIcon;
  visaIconDisabled = VisaIconDisabled;

  icons = {
    [ICON_VISA]: this.visaIcon,
    [ICON_STAR]: this.starIcon,
  };

  iconsDisabled = {
    [ICON_VISA]: this.visaIconDisabled,
  };

  get widgetIcon() {
    return this.icon ? this.icons[this.icon] : this.image;
  }

  get widgetIconDisabled() {
    if (this.imageDisabled) return this.imageDisabled;

    if (this.icon) return this.iconsDisabled[this.icon];

    return this.widgetIcon;
  }

  get hintText() {
    if (this.disabled) return this.hint;

    return "";
  }

  get classes() {
    const { disabled, type, short } = this;

    return {
      [`${CLASS}-active`]: !disabled,
      [`${CLASS}-disabled`]: disabled,
      [`${CLASS}-${TYPE_BLUE}`]: type === TYPE_BLUE,
      [`${CLASS}-${TYPE_PURPLE}`]: type === TYPE_PURPLE,
      [`${CLASS}-${TYPE_WHITE}`]: short,
    };
  }

  onClick() {
    if (this.disabled) return;

    this.$emit("click");
  }
}
